module.exports = __webpack_public_path__ + "static/media/appointments.9542d33b.svg";